import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import _ from 'underscore'
import classNames from 'classnames'
import HighlightedTextarea from './HighlightedTextarea'
import { charCountLimit } from './index'
import { checkIfEmpty } from '../../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import Loader from '../Loader'
import { updateEditDynamicDataState } from '../../actions/AspireEditDynamicData'
import { editModalAriaLabel } from '../Constants/AriaLabelText'
import ThreeDotsButton from './HelperComponents/ThreeDotsButton'
import SaveBtn from './HelperComponents/SaveBtn'


class Headline extends Component {
  


  constructor(props) {
    super(props)
    this.state = {
      selectedPresentCategory: '',
      selectedSkill: '',
      focused: {
        text: false,
      },
      checkbox: {
        tense: false,
        narrative_voice: false,
        buzzwords: false,
        verb_overusage: false,
        action_oriented: false,
        specifics: false,
      },
      textValue: '',
      headlineSuggestionsIndex: 0,
      iimmumbaiExampleIndex: 0,
    }
    this.suggestionsLength = 0
    this.suggestions = []
    this.headlineSuggestionText = []
    this.pdfModal = null
    this.legendArr = []
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.updateCheckboxState = this.updateCheckboxState.bind(this)
    this.handleUndoClick = this.handleUndoClick.bind(this)
    this.highlightValues = this.highlightValues.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleCloseButton = this.handleCloseButton.bind(this)
    this.setSelectedSkill = this.setSelectedSkill.bind(this)
    this.setSelectedPresentCategory = this.setSelectedPresentCategory.bind(this)
    this.headlineCharsRemaining = charCountLimit['headline']['text']
    this.sendTrackingDataDebounceSample = _.debounce(
      sendTrackingData,
      3000,
      true
    )
    this.sendTrackingDataDebounceUndo = _.debounce(sendTrackingData, 3000, true)
    this.placeholders = {
      text: this.props.intl.formatMessage({
        id: 'aspire.headline.placeholder.enterHeadline',
        defaultMessage: 'Enter headline',
      }),
    }

    this.categoryLabels = {
      certifications: this.props.intl.formatMessage({
        id: 'aspire.headline.category.certifications',
        defaultMessage: 'Certifications',
      }),
      education_current: this.props.intl.formatMessage({
        id: 'aspire.headline.category.currentEducation',
        defaultMessage: 'Current education',
      }),
      education_opportunity: this.props.intl.formatMessage({
        id: 'aspire.headline.category.seekingOpportunity',
        defaultMessage: 'Seeking opportunity',
      }),
      education_prev_current: this.props.intl.formatMessage({
        id: 'aspire.headline.category.education',
        defaultMessage: 'Education',
      }),
      experience: this.props.intl.formatMessage({
        id: 'aspire.headline.category.currentEducation',
        defaultMessage: 'Current experience',
      }),
      latest_experience_club: this.props.intl.formatMessage({
        id: 'aspire.headline.category.club',
        defaultMessage: 'Club',
      }),
      latest_experience_degree: this.props.intl.formatMessage({
        id: 'aspire.headline.category.degree',
        defaultMessage: 'Degree',
      }),
      opportunity: this.props.intl.formatMessage({
        id: 'aspire.headline.category.seekingOpportunity',
        defaultMessage: 'Seeking opportunity',
      }),
      past_relevant_job_role: this.props.intl.formatMessage({
        id: 'aspire.headline.category.jobRole',
        defaultMessage: 'Job role',
      }),
      skills: this.props.intl.formatMessage({
        id: 'aspire.headline.category.topRelevantSkills',
        defaultMessage: 'Top relevant skills',
      }),
    }
  }
  UNSAFE_componentWillMount() {
    this.headlineSuggestions(this.props.feedback['suggestions'])
    this.getTextFromSuggestion(this.props.feedback['suggestions'])
    let text = ''
    if (
      this.props.sectionWiseTextEditable[this.props.currentIndex]['text'] !==
      'N/A'
    ) {
      text = this.props.sectionWiseTextEditable[this.props.currentIndex]['text']
    }
    this.headlineCharsRemaining =
      charCountLimit['headline']['text'] - text.length
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.updateEditSection === true) {
      this.setState({
        textValue:
          nextProps.sectionWiseTextEditable[nextProps.currentIndex]['text'],
      })
    }
    if (
      nextProps['feedback'].hasOwnProperty('suggestions') &&
      nextProps['feedback']['suggestions'].hasOwnProperty('suggestions_text')
    ) {
      if (
        JSON.stringify(
          nextProps.feedback['suggestions']['suggestions_text']
        ) !==
        JSON.stringify(this.props.feedback['suggestions']['suggestions_text'])
      ) {
        this.headlineSuggestions(nextProps.feedback['suggestions'])
        this.getTextFromSuggestion(nextProps.feedback['suggestions'])
        this.setState({ headlineSuggestionsIndex: 0 })
      }
    }
    this.props.underlineEntitySpellError()
  }

  setSelectedSkill(skill) {
    this.setState({ selectedSkill: skill })
  }

  setSelectedPresentCategory(category) {
    this.setState({ selectedPresentCategory: category })
  }

  handleChange(e) {
    const value = e.target.value
    this.props.handleOnChangeData(
      'headline',
      this.props.currentIndex,
      'text',
      value
    )
    this.setState({
      textValue:
        this.props.sectionWiseTextEditable[this.props.currentIndex]['text'],
    })
    let charsRemainingCount = -1
    if (
      charCountLimit.hasOwnProperty('headline') &&
      charCountLimit['headline'].hasOwnProperty('text')
    ) {
      charsRemainingCount = charCountLimit['headline']['text'] - value.length
    }

    this.headlineCharsRemaining = charsRemainingCount
  }

  handleUndoClick() {
    const { currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'undo_changes_btn',
      currentSection: 'Headline',
      currentIndex: currentIndex,
    }

    this.sendTrackingDataDebounceUndo(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.props.handleUndoData('headline', this.props.currentIndex)
    let text = ''
    if (
      this.props.sectionWiseTextStatic[this.props.currentIndex]['text'] !==
      'N/A'
    ) {
      text = this.props.sectionWiseTextStatic[this.props.currentIndex]['text']
    }
    this.headlineCharsRemaining =
      charCountLimit['headline']['text'] - text.length
  }

  handleFocus(field, e) {
    e.preventDefault()
    let focused = this.state.focused

    for (let i in focused) {
      if (i == field) {
        focused[i] = true
      } else {
        focused[i] = false
      }
    }

    let checkbox = {
      tense: false,
      narrative_voice: false,
      buzzwords: false,
      verb_overusage: false,
      action_oriented: false,
      specifics: false,
    }

    this.setState({
      focused: focused,
      checkbox: checkbox,
      selectedPresentCategory: '',
    })
  }

  handleBlur(field) {
    let focused = this.state.focused
    focused[field] = false
    this.setState({ focused: focused })
  }

  handleCloseButton() {
    const {
      handleUndoData,
      currentIndex,
      hideEditModal,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
    } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'close_btn',
      currentSection: 'Headline',
      currentIndex: currentIndex,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    hideEditModal(
      'headline',
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic
    )
  }

  renderPlaceholder(text, field) {
    if (!_.isEmpty(text)) {
      return text
    }

    return <span className="placeholder-color">{this.placeholders[field]}</span>
  }

  updateCheckboxState(checkbox) {
    this.setState({ checkbox: checkbox })
  }

  highlightValues(input) {
    return this.props.highlightableDivWords
  }

  renderEntityText(entity) {
    const { savingChanges, intl } = this.props

    let fieldDisabled = false
    if (savingChanges) {
      fieldDisabled = true
    }

    if (entity == 'text') {
      let { sectionWiseTextEditable, currentIndex } = this.props
      let text = ''
      if (
        this.props.sectionWiseTextEditable[this.props.currentIndex]['text'] !==
        'N/A'
      ) {
        text =
          this.props.sectionWiseTextEditable[this.props.currentIndex]['text']
      }

      return (
        <div className="edit-headline">
          <HighlightedTextarea
            name="text"
            label={intl.formatMessage({
              id: 'aspire.headline.label.headline',
              defaultMessage: 'Headline',
            })}
            highlight={this.highlightValues}
            value={text}
            placeholder={this.placeholders['text']}
            onFocus={(e) => this.handleFocus('text', e)}
            onBlur={() => this.handleBlur('text')}
            onChange={this.handleChange}
            disabled={fieldDisabled}
          />
          <span className="education-chars-remain description">
            <span>
              <FormattedMessage
                id="aspire.headline.text.linkedInGuidelines"
                defaultMessage="The character count is maintained in accordance with LinkedIn guidelines"
              />
            </span>
          </span>
          <span className="education-chars-remain">
            <span>
              {charCountLimit['headline']['text'] - this.headlineCharsRemaining}
            </span>
            /{charCountLimit['headline']['text']}
          </span>
        </div>
      )
    }
  }

  prevSample() {
    const { currentIndex } = this.props
    if (this.state.headlineSuggestionsIndex > 0) {
      let jsonObjectForTracking = {
        eventLabel: 'previous_sample_btn',
        currentSection: 'Headline',
        currentIndex: currentIndex,
        currentSampleIndex: this.state.index,
      }
      this.sendTrackingDataDebounceSample(
        'event',
        'aspire_edit_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
      this.setState((prevState) => ({
        headlineSuggestionsIndex: prevState.headlineSuggestionsIndex - 1,
      }))
    }
  }

  nextSample(len) {
    const { currentIndex } = this.props
    if (this.state.headlineSuggestionsIndex < len - 1) {
      let jsonObjectForTracking = {
        eventLabel: 'next_sample_btn',
        currentSection: 'Headline',
        currentIndex: currentIndex,
        currentSampleIndex: this.state.index,
      }
      this.sendTrackingDataDebounceSample(
        'event',
        'aspire_edit_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
      this.setState((prevState) => ({
        headlineSuggestionsIndex: prevState.headlineSuggestionsIndex + 1,
      }))
    }
  }

  getTextFromSuggestion(suggestions2) {
    if (_.isEmpty(suggestions2)) {
      return
    }

    let maxCount = 4
    let suggestions = [].concat(suggestions2['suggestions_text'])
    suggestions = suggestions.slice(0, maxCount)

    this.headlineSuggestionText = suggestions
  }

  headlineSuggestions(suggestions2) {
    if (_.isEmpty(suggestions2)) {
      return
    }

    let maxCount = 4
    let suggestions = [].concat(suggestions2['suggestions'])
    suggestions = suggestions.slice(0, maxCount)
    let legend = [].concat(suggestions2['legend'])
    legend = legend.slice(0, maxCount)
    this.suggestionsLength = suggestions.length
    let pdfModal = []
    const { processingStatus, has_pdf, intl } = this.props

    let legendArr = {}
    let temp = []
    for (let index in legend) {
      legendArr[index] = []

      for (let i in legend[index]) {
        temp.push(
          <span
            className={classNames(
              'margin-r-3',
              { 'pull-left': i % 2 == 0 },
              { 'pull-left': i % 2 == 1 }
            )}>
            <span className={'headline-suggestion'}>&nbsp; &nbsp;</span>
            {'  ' + this.categoryLabels[legend[index][i]]}
          </span>
        )
        if (i % 3 == 2) {
          legendArr[index].push(<div>{temp}</div>)
          legendArr[index].push(<br />)
          temp = []
        }
      }

      if (!_.isEmpty(temp)) {
        legendArr[index].push(<div>{temp}</div>)
        legendArr[index].push(<br />)
        temp = []
      }
    }

    if (has_pdf != '1') {
      if (processingStatus == 'processing' || _.isNull(processingStatus)) {
        pdfModal.push(
          <div className="headline-pdf-modal-msg">
            <b>
              <FormattedMessage
                id="aspire.headline.text.uploadProfile"
                defaultMessage="Upload full profile for better headline suggestions"
              />
            </b>
          </div>
        )
      } else {
        pdfModal.push(
          <div className="headline-pdf-modal-msg">
            <b>
              <FormattedMessage
                id="aspire.headline.text.uploadProfile"
                defaultMessage="Upload full profile for better headline suggestions"
              />
            </b>
          </div>
        )
      }
    }

    this.suggestions = suggestions
    this.pdfModal = pdfModal
    this.legendArr = legendArr
  }  

  handleDotClick(index) {
    const { currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'sample_dot_clicked',
      currentSection: 'Headline',
      currentIndex: currentIndex,
      clickedSampleIndex: index,
    }
    this.sendTrackingDataDebounceSample(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.setState({ headlineSuggestionsIndex: index })
  }

  getIndicatorDots(index, len) {
    let dots = []
    for (let i = 0; i < len; i++) {
      if (i == index) {
        dots.push(
          <div
            key={`as-headline-suggestions-indicator-dots-${i}`}
            className="as-headline-suggestions-indicator-dots as-headline-suggestions-indicator-dots-light"
          />
        )
      } else {
        dots.push(
          <div
            key={`as-headline-suggestions-indicator-dots-${i}`}
            className="as-headline-suggestions-indicator-dots as-headline-suggestions-indicator-dots-dark"
            onClick={() => this.handleDotClick(i)}
          />
        )
      }
    }

    return <div className="as-sample-indicator">{dots}</div>
  }

  getPreviousButton(index, len) {
    const { intl } = this.props
    if (index !== 0) {
      return (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['previous_sample']}
          className="as-headline-suggestions-btn as-headline-suggestions-btn-prev"
          onClick={() => this.prevSample()}>
          <span className="arrow arrow-left" />
        </button>
      )
    } else {
      return (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['previous_sample']}
          className="as-headline-suggestions-btn as-headline-suggestions-btn-prev disabled"
          disabled>
          <span className="arrow arrow-left" />
        </button>
      )
    }
  }

  getNextButton(index, len) {
    const { intl } = this.props
    if (index !== len - 1) {
      return (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['next_sample']}
          className="as-headline-suggestions-btn as-headline-suggestions-btn-next"
          onClick={() => this.nextSample(len)}>
          <span className="arrow arrow-right" />
        </button>
      )
    } else {
      return (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['next_sample']}
          className="as-headline-suggestions-btn as-headline-suggestions-btn-next disabled"
          disabled>
          <span className="arrow arrow-right" />
        </button>
      )
    }
  }

  getStaticSuggestion() {
    const { intl, user } = this.props;
    const { community } = user || {};
    if( community === 'mofo' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.headline.writingTipsHeadlineMofo" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.headline.writingTipsTextMofo" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.headline.tipsToGetStartedHeadlineMofo" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.headline.tipsToGetStartedTextMofo" }),
      };
    }
    if( community === 'iimmumbai' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.headline.writingTipsHeadlineIIMMumbai" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.headline.writingTipsTextIIMMumbai" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.headline.tipsToGetStartedHeadlineIIMMumbai" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.headline.tipsToGetStartedTextIIMMumbai" }),
        examples: [
          { headline: intl.formatMessage({ id: "staticSuggestion.headline.exampleHeadline1IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.headline.exampleText1IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.headline.exampleHeadline2IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.headline.exampleText2IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.headline.exampleHeadline3IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.headline.exampleText3IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.headline.exampleHeadline4IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.headline.exampleText4IIMMumbai" }) },
        ],
      };
    }
    return {
      writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.headline.writingTipsHeadline" }),
      writingTipsText: intl.formatMessage({ id: "staticSuggestion.headline.writingTipsText" }),
      tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.headline.tipsToGetStartedHeadline" }),
      tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.headline.tipsToGetStartedText" }),
    };
  }

  render() {
    const {
      savingChanges,
      currentIndex,
      newSubSection,
      hideEditModal,
      sectionWiseText,
      sectionWiseTextStatic,
      sectionWiseTextEditable,
      highlightEntityText,
      unhighlightAll,
      feedback,
      handleSaveChanges,
      handleUndoData,
      fetchId,
      showLogModal,
      intl,
      isRightNavToggle,
    } = this.props

    let undoButton = null
    let saveDisabled = true
    if (
      !(
        JSON.stringify(sectionWiseTextEditable[currentIndex]) ===
          JSON.stringify(sectionWiseTextStatic[currentIndex]) || savingChanges
      )
    ) {
      saveDisabled = false
      undoButton = (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['reset']}
          className="btn btn-undo-changes"
          onClick={this.handleUndoClick}>
          {intl.formatMessage({
            id: 'aspire.headline.button.reset',
            defaultMessage: 'Reset',
          })}
        </button>
      )
    }

    let saveButton = (
      <SaveBtn
        savingChanges={savingChanges}
        saveDisabled={saveDisabled}
        handleSaveChanges={handleSaveChanges}
        intl={intl}
      />
    )

    let editOrAdd =
      !_.isUndefined(currentIndex) &&
      _.isString(currentIndex) &&
      currentIndex.substr(-4) === '_new'
        ?
          intl.formatMessage({
            id: 'aspire.headline.button.add',
            defaultMessage: 'Add',
          })
        :
          intl.formatMessage({
            id: 'aspire.headline.button.edit',
            defaultMessage: 'Edit',
          })

    let headlineSuggestions = null
    if (this.suggestionsLength > 0) {
      headlineSuggestions = (
        <>
          <div className="as-headline-sample-outer-wrapper">
            <div className="as-sample-wrapper as-sample-wrapper-headline">
              <div className="as-sample-change-left">
                <div
                  className={`as-sample-bottom-change-headline ${
                    this.suggestionsLength === 1 ? 'hide-btn' : ''
                  }`}>
                  {this.getPreviousButton(
                    this.state.headlineSuggestionsIndex,
                    this.suggestionsLength
                  )}
                </div>
                <div className="clearfix" />
              </div>
              <div className="as-sample-example as-sample-example-headline">
                <div
                  tabIndex={0}
                  aria-label={
                    this.headlineSuggestionText[
                      this.state.headlineSuggestionsIndex
                    ]
                  }
                  className="as-sample-example-text-headline"
                  id="scrollItToTop">
                  <div className="as-all-lists-heading-wrapper">
                    <div
                      className="as-all-lists-heading-text"
                      tabIndex={0}
                      aria-label={editModalAriaLabel(intl)['Headline']['headline']}>
                      {intl.formatMessage({
                        id: 'aspire.headline.heading.suggestions',
                        defaultMessage: 'Headline suggestions basis your profile',
                      })}
                    </div>
                  </div>
                  {this.suggestions[this.state.headlineSuggestionsIndex]}
                </div>
              </div>
              <div className="as-sample-change-right">
                <div
                  className={`as-sample-bottom-change-headline ${
                    this.suggestionsLength === 1 ? 'hide-btn' : ''
                  }`}>
                  {this.getNextButton(
                    this.state.headlineSuggestionsIndex,
                    this.suggestionsLength
                  )}
                </div>
                <div className="clearfix" />
              </div>
            </div>
            <div className="as-sample-change-headline">
              <div
                className={`as-sample-bottom-buttons-headline ${
                  this.suggestionsLength === 1 ? 'hide-btn' : ''
                }`}>
                {this.getIndicatorDots(
                  this.state.headlineSuggestionsIndex,
                  this.suggestionsLength
                )}
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </>
      )
    }

    // calculation for focused state and black overlay
    let blackOverlayClass = ''
    let editFocusedClass = ''

    if (savingChanges) {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
      $('.edit-headline .hwt-content').css('font-size', '16px')
      $('.edit-headline .hwt-content').css('line-height', '24px')
    } else if (this.state.focused.text) {
      blackOverlayClass = 'as-edit-overlay-none as-edit-overlay-black'
      editFocusedClass = 'as-edit-focused-none as-edit-focused-black'
      $('.edit-headline .hwt-content').css('font-size', '16px')
      $('.edit-headline .hwt-content').css('line-height', '24px')
    } else {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
      $('.edit-headline .hwt-content').css('font-size', '16px')
      $('.edit-headline .hwt-content').css('line-height', '24px')
    }

    let threeDotsBtn = (
      <ThreeDotsButton showLogModal={showLogModal} section="Headline" />
    )

    const headlineTips = this.getStaticSuggestion();

    return (
      <div className="as-edit-wrapper scroll-hidden">
        <Loader sectionName="Headline" />
        <div className="as-edit-close-div">
          <a
            href="javascript:void(0);"
            aria-label={editModalAriaLabel(intl)['close']}
            onClick={this.handleCloseButton}
            className="icon-cross as-edit-close-btn modal-close-button"
            style={!isRightNavToggle ? { right: '17%' } : {}}
          />
        </div>
        <div className="as-edit-heading-wrapper">
          <div className="as-edit-heading" role="heading" aria-level="3">
            {intl.formatMessage({
              id: 'aspire.headline.heading.headline',
              defaultMessage: 'Headline',
            })}
          </div>
          <div className="as-edit-actions-div">
            <div className="as-edit-action-undo">{undoButton}</div>
            <div className="as-edit-action-save">{saveButton}</div>
            {threeDotsBtn}
          </div>
        </div>
        <div
          className="as-edit-container as-headline-container"
          id="vertical-scroll">
          <div className={editFocusedClass}>
            <div className="as-edit-inputs-row-headline">
              <div className="as-edit-inputs-col-headline max-tall">
                {this.renderEntityText('text')}
              </div>
            </div>
          </div>
        </div>
        <div className="as-edit-info-div">
          <div className="as-edit-suggestions-heading">
            <span
              role="text"
              tabIndex={0}
              aria-label={headlineTips.writingTipsHeadline}>
              {headlineTips.writingTipsHeadline}
            </span>
          </div>
          <div className="as-edit-card-headline-education">
            {/* {headlineSuggestions} */}
            {
                <div className="tips-section">
                  <div style={{ whiteSpace: 'pre-line' }}>
                    {headlineTips.writingTipsText}
                  </div>
                  <div className="tips-heading">
                    {headlineTips.tipsToGetStartedHeadline}
                  </div>
                  <div style={{ whiteSpace: 'pre-line' }}>
                    {headlineTips.tipsToGetStartedText}
                  </div>
                  {!headlineTips.examples && headlineTips.exampleHeadline ? (
                    <div>
                      <div className="tips-heading">{headlineTips.exampleHeadline}</div>
                      <div style={{ whiteSpace: 'pre-line' }}>{headlineTips.exampleText}</div>
                    </div>
                  ) : null}
                </div>
              }
              {headlineTips.examples ? (
                <div className="sample-carousel-wrapper">
                  <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === 0} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex - 1 })} className="sample-carousel-btn sample-carousel-btn-prev">
                    <span className="arrow arrow-left" />
                  </button>
                  <div className="sample-carousel-card">
                    <div className="tips-heading">
                      {'Sample ' + (this.state.iimmumbaiExampleIndex + 1) + ' of ' + headlineTips.examples.length + ' › ' + headlineTips.examples[this.state.iimmumbaiExampleIndex].headline}
                    </div>
                    <div style={{ whiteSpace: 'pre-line' }}>{headlineTips.examples[this.state.iimmumbaiExampleIndex].text}</div>
                  </div>
                  <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === headlineTips.examples.length - 1} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex + 1 })} className="sample-carousel-btn sample-carousel-btn-next">
                    <span className="arrow arrow-right" />
                  </button>
                </div>
              ) : null}
          </div>
        </div>
      </div>
    )
  }

  componentWillUnmount() {
    const { updateEditDynamicDataState } = this.props
    updateEditDynamicDataState({
      updateKeys: [
        ['fetchedContent'],
        ['fetchingContent'],
        ['dataContent'],
        ['errorContent'],
        ['fetchedSkills'],
        ['fetchingSkills'],
        ['dataSkills'],
        ['errorSkills'],
        ['fetchedLanguage'],
        ['fetchingLanguage'],
        ['dataLanguage'],
        ['errorLanguage'],
        ['fetchedImpact'],
        ['fetchingImpact'],
        ['dataImpact'],
        ['errorImpact'],
        ['fetchedRephraseWords'],
        ['fetchingRephraseWords'],
        ['dataRephraseWords'],
        ['errorRephraseWords'],
      ],
      data: {
        fetchedContent: false,
        fetchingContent: false,
        dataContent: null,
        errorContent: false,
        fetchedSkills: false,
        fetchingSkills: false,
        dataSkills: null,
        errorSkills: false,
        fetchedLanguage: false,
        fetchingLanguage: false,
        dataLanguage: null,
        errorLanguage: false,
        fetchedImpact: false,
        fetchingImpact: false,
        dataImpact: null,
        errorImpact: false,
        fetchedRephraseWords: false,
        fetchingRephraseWords: false,
        dataRephraseWords: null,
        errorRephraseWords: false,
      },
    })
  }
}

function mapStateToProps(state, ownProps) {
  return {
    savingChanges:
      !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
      ownProps.uploadingEditedData,
    isRightNavToggle: state.editData.isRightNavToggle,
    user: state.user.data,
  }
}

export default connect(mapStateToProps, { updateEditDynamicDataState })(
  injectIntl(Headline)
)
